import React, { useEffect } from 'react'
import { useController, Control } from 'react-hook-form'
import { Label, Input, HiddenCheckbox, StyledCheckbox } from '../styles/modal-style'
import { FieldInTicket, Ticket } from './Modals/ViewOrEditTicket'
import CurrencyInput from '../CurrencyInput'
import InfiniteSelect from '../InfiniteSelect'
import axios from '../../config/axios'

interface PropsInterface {
  field: FieldInTicket
  setValue: React.Dispatch<React.SetStateAction<Ticket>>
  isFilled: boolean
  control?: Control<any>
}

const RenderField:React.FC<PropsInterface> = ({field, setValue, isFilled}) => {
  const typeId = field.pipelineField.typeFieldId
  const typeName = field.pipelineField.typeField?.name || ''
  const integrationConfig = field.pipelineField.integrationConfig
  const isIntegrated = !!integrationConfig
  
  const [sampleData, setSampleData] = React.useState<any>(null)
  const [searchTerm, setSearchTerm] = React.useState<string>('')
  
  const getNestedValue = React.useCallback((obj: any, path: string): any => {
    console.log('🔵 [getNestedValue] path:', path, '| obj keys:', obj ? Object.keys(obj) : 'null')
    const keys = path.split('.')
    let val = obj
    for (const k of keys) {
      if (val === null || val === undefined) {
        console.log('🔵 [getNestedValue] val é null/undefined no key:', k)
        return null
      }
      console.log('🔵 [getNestedValue] navegando key:', k, '| val[k]:', val[k])
      val = val[k]
    }
    console.log('🔵 [getNestedValue] resultado final:', val)
    return val
  }, [])
  
  const hasValidFieldValue = React.useCallback((item: any, fieldKey: string): boolean => {
    const value = getNestedValue(item, fieldKey)
    
    console.log('🟡 [hasValidFieldValue] item:', item.id, '| fieldKey:', fieldKey, '| value:', value, '| type:', typeof value, '| isArray:', Array.isArray(value))
    
    if (value === null || value === undefined) {
      console.log('🟡 [hasValidFieldValue] REJEITADO: null/undefined')
      return false
    }
    if (value === '') {
      console.log('🟡 [hasValidFieldValue] REJEITADO: string vazia')
      return false
    }
    if (Array.isArray(value) && value.length === 0) {
      console.log('🟡 [hasValidFieldValue] REJEITADO: array vazio')
      return false
    }
    if (typeof value === 'object' && !Array.isArray(value)) {
      const objName = value.name || value.typeName || value.companyName || value.id
      console.log('🟡 [hasValidFieldValue] É objeto, objName:', objName)
      return objName !== null && objName !== undefined && objName !== ''
    }
    console.log('🟡 [hasValidFieldValue] ACEITO')
    return true
  }, [getNestedValue])
  
  const getDisplayValueFromField = React.useCallback((item: any, fieldKey: string): string => {
    const value = getNestedValue(item, fieldKey)
    
    if (value === null || value === undefined) return ''
    if (Array.isArray(value)) {
      return value.map(v => typeof v === 'object' ? (v.name || v.typeName || v.id || '') : String(v)).join(', ')
    }
    if (typeof value === 'object') {
      return value.name || value.typeName || value.companyName || String(value.id || '')
    }
    return String(value)
  }, [getNestedValue])
  
  useEffect(() => {
    const fetchIntegrationDataOnMount = async () => {
      if (!isIntegrated || !integrationConfig || !field.integerValue || (field as any).integrationData) return
      
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_GATEWAY_BASE_URL}${integrationConfig.endpoint}/${field.integerValue}`
        )
        const data = response.data?.data || response.data
        
        if (data) {
          setSampleData(data)
          setValue(prev => ({
            ...prev,
            fieldInTickets: prev.fieldInTickets.map(f => f.pipelineFieldId === field.pipelineFieldId ? {
              ...f,
              integrationData: data
            } : f)
          }))
        }
      } catch (error) {
        console.error('Erro ao buscar dados integrados:', error)
      }
    }
    
    fetchIntegrationDataOnMount()
  }, [field.integerValue, isIntegrated])
  
  console.log('🔍 [RENDER FIELD] Campo:', field.pipelineField.name);
  console.log('🔍 [RENDER FIELD] TypeId:', typeId);
  console.log('🔍 [RENDER FIELD] TypeField:', field.pipelineField.typeField);
  console.log('🔍 [RENDER FIELD] TypeName:', typeName);
  
  const isEmail = typeName === 'E-mail'
  const isCpf = typeName === 'CPF'
  const isCnpj = typeName === 'CNPJ'
  const isDate = typeName === 'Data'
  const isCheckbox = typeName === 'Checkbox'
  const isCelular = typeName === 'Celular'
  const isTelefone = typeName === 'Telefone'
  const isTexto = typeName === 'Texto simples'
  const isValor = typeName === 'Valor (R$)'
  const isString = isEmail || isCpf || isCnpj || isCelular || isTelefone || isTexto
  
  console.log('🔍 [RENDER FIELD] Tipo detectado:', {
    isEmail, isCpf, isCnpj, isDate, isCheckbox, isCelular, isTelefone, isTexto, isValor, isString, isIntegrated
  });

  const maskCpf = (v: string) => v.replace(/\D/g, '').slice(0,11).replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d{1,2})$/, '$1-$2')
  const maskCnpj = (v: string) => v.replace(/\D/g, '').slice(0,14).replace(/(\d{2})(\d)/, '$1.$2').replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d)/, '$1/$2').replace(/(\d{4})(\d{1,2})$/, '$1-$2')
  const maskPhone = (v: string) => {
    const digits = v.replace(/\D/g, '')
    if (isCelular) {
      const sliced = digits.slice(0,11)
      if (sliced.length <= 10) return sliced.replace(/(\d{2})(\d{0,4})(\d{0,4})/, (_, a, b, c) => c ? `(${a}) ${b}-${c}` : b ? `(${a}) ${b}` : `(${a}`)
      return sliced.replace(/(\d{2})(\d{5})(\d{0,4})/, (_, a, b, c) => c ? `(${a}) ${b}-${c}` : `(${a}) ${b}`)
    }
    const sliced = digits.slice(0,10)
    return sliced.replace(/(\d{2})(\d{0,4})(\d{0,4})/, (_, a, b, c) => c ? `(${a}) ${b}-${c}` : b ? `(${a}) ${b}` : `(${a}`)
  }

  const placeholder = isTexto ? 'Digite aqui' : 'Digite...'

  const handleStringChange = (raw: string) => {
    let formatted = raw
    if (isCpf) formatted = maskCpf(raw)
    if (isCnpj) formatted = maskCnpj(raw)
    if (isCelular || isTelefone) formatted = maskPhone(raw)

    setValue(prev => ({
      ...prev,
      fieldInTickets: prev.fieldInTickets.map(f => f.pipelineFieldId === field.pipelineFieldId ? {
        ...f,
        stringValue: formatted
      } : f)
    }))
  }

  const handleDecimalChange = (_value: string | undefined, _name?: string, values?: any) => {
    const floatValue = values?.float
    setValue(prev => ({
      ...prev,
      fieldInTickets: prev.fieldInTickets.map(f => f.pipelineFieldId === field.pipelineFieldId ? {
        ...f,
        decimalValue: floatValue
      } : f)
    }))
  }

  const handleDateChange = (value: string) => {
    setValue(prev => ({
      ...prev,
      fieldInTickets: prev.fieldInTickets.map(f => f.pipelineFieldId === field.pipelineFieldId ? {
        ...f,
        dateTimeValue: value
      } : f)
    }))
  }

  const handleToggle = () => {
    setValue(prev => ({
      ...prev,
      fieldInTickets: prev.fieldInTickets.map(f => f.pipelineFieldId === field.pipelineFieldId ? {
        ...f,
        booleanValue: !f.booleanValue
      } : f)
    }))
  }

  const handleIntegrationSelect = (option: any | null) => {
    const fieldKey = integrationConfig?.fieldKey || 'name'
    const displayValue = option?.[fieldKey] ? String(option[fieldKey]) : ''
    
    setValue(prev => ({
      ...prev,
      fieldInTickets: prev.fieldInTickets.map(f => f.pipelineFieldId === field.pipelineFieldId ? {
        ...f,
        integerValue: option?.id || null,
        stringValue: displayValue,
        integrationData: option || null
      } : f)
    }))
  }

  const fetchIntegrationData = React.useCallback(async (limit: number, offset: number, search?: string) => {
    console.log('🔍 [FETCH] Iniciando busca:', { limit, offset, search })
    
    if (!integrationConfig) {
      console.log('🔍 [FETCH] Sem integrationConfig, retornando vazio')
      return []
    }
    
    const fieldKey = integrationConfig.fieldKey
    
    console.log('🔍 [FETCH] fieldKey:', fieldKey)

    const url = `${process.env.REACT_APP_GATEWAY_BASE_URL}${integrationConfig.endpoint}`
    const params: any = { 
      limit: 100,
      offset: 0
    }
    
    console.log('🔍 [FETCH] URL:', url)
    console.log('🔍 [FETCH] Params:', params)

    try {
      const response = await axios.get(url, { params })
      
      console.log('🔍 [FETCH] Response raw:', response.data)
      
      const data = response.data?.data || response.data || []
      const dataArray = Array.isArray(data) ? data : []
      
      console.log('🔍 [FETCH] DataArray length:', dataArray.length)
      
      if (dataArray.length > 0 && !sampleData) {
        setSampleData(dataArray[0])
      }
      
      const filteredData = dataArray.filter((item: any) => {
        const isValid = hasValidFieldValue(item, fieldKey)
        console.log('🔍 [FILTER FK] Item:', item.id, item.name || item.companyName, '| fieldKey:', fieldKey, '| válido:', isValid)
        return isValid
      })
      
      console.log('🔍 [FETCH] Após filtro FK:', filteredData.length, 'de', dataArray.length)
      
      if (search && search.trim()) {
        const searchLower = search.toLowerCase().trim()
        console.log('🔍 [SEARCH] Filtrando client-side por:', searchLower)
        
        const searchFiltered = filteredData.filter((item: any) => {
          const displayValue = getDisplayValueFromField(item, fieldKey)
          const itemName = item.name || item.companyName || ''
          const matches = displayValue.toLowerCase().includes(searchLower) || 
                 itemName.toLowerCase().includes(searchLower) ||
                 String(item.id || '').includes(searchLower)
          console.log('🔍 [SEARCH] Item:', item.id, '| displayValue:', displayValue, '| itemName:', itemName, '| matches:', matches)
          return matches
        })
        
        console.log('🔍 [SEARCH] Resultado final:', searchFiltered.length)
        return searchFiltered
      }
      
      console.log('🔍 [FETCH] Retornando:', filteredData.length, 'itens')
      return filteredData
    } catch (error) {
      console.error('🔍 [FETCH] Erro:', error)
      return []
    }
  }, [integrationConfig, sampleData, hasValidFieldValue, getDisplayValueFromField])

  const getIntegrationDisplayValue = () => {
    if (field.integerValue && field.stringValue) {
      return { id: field.integerValue, name: field.stringValue }
    }
    return null
  }
  
  const translateFieldLabel = (key: string): string => {
    const translations: Record<string, string> = {
      'id': 'ID',
      'name': 'Nome',
      'email': 'E-mail',
      'password': 'Senha',
      'cnpj': 'CNPJ',
      'company': 'Empresa',
      'companyName': 'Razão Social',
      'phone': 'Telefone',
      'adminUser': 'Usuário Admin',
      'picture': 'Foto',
      'approved': 'Aprovado',
      'role': 'Papel',
      'tenantId': 'ID do Tenant',
      'createdAt': 'Criado em',
      'updatedAt': 'Atualizado em',
      'updateAt': 'Atualizado em',
      'expiresAt': 'Expira em',
      'token': 'Token',
      'resetToken': 'Token de Reset',
      'resetTokenExpiresAt': 'Token expira em',
      'code': 'Código',
      'density': 'Densidade',
      'stateRegistration': 'Inscrição Estadual',
      'contactName': 'Nome do Contato',
      'activedDays': 'Dias Ativos',
      'startTime': 'Início',
      'endTime': 'Término',
      'addressId': 'ID do Endereço',
      'cpf': 'CPF',
      'isMain': 'Principal',
      'typeName': 'Nome do Tipo',
      'status': 'Status',
      'productionPace': 'Ritmo de Produção',
      'productionDay': 'Dia de Produção',
      'codeOfOP': 'Código da OP',
      'integratedWithOmie': 'Integrado com Omie',
      'usedQuantity': 'Qtd Usada',
      'usedUnitOfMeasurement': 'Unid Medida Usada',
      'action': 'Ação',
      'dateTime': 'Data e Hora',
      'description': 'Descrição',
      'newValue': 'Novo Valor',
      'oldValue': 'Antigo Valor',
      'completed': 'Concluído',
      'observation': 'Observação',
      'index': 'Índice',
      'fileUrl': 'URL do Arquivo',
      'executeDate': 'Data de Execução',
      'completedAt': 'Concluído em',
      'startedAt': 'Iniciado em',
      'uf': 'UF',
      'cep': 'CEP',
      'street': 'Rua',
      'complement': 'Complemento',
      'number': 'Número',
      'attachments': 'Anexos',
      'deliveryDate': 'Data de Entrega',
      'extraInfo': 'Info Extra',
      'orderDate': 'Data do Pedido',
      'orderType': 'Tipo do Pedido',
      'paymentTerm': 'Prazo Pagamento',
      'shippingType': 'Tipo de Frete',
      'shippingValue': 'Valor do Frete',
      'taxes': 'Impostos',
      'total': 'Total',
      'trackingCode': 'Código de Rastreio',
      'totalQuantity': 'Qtd Total',
      'originDealIdPloomes': 'ID Negócio Ploomes',
      'saleNumberPloomes': 'Nº Venda Ploomes',
      'isPrincipal': 'Principal',
      'descount': 'Desconto',
      'priceKg': 'Preço/Kg',
      'priceKgMin': 'Preço/Kg Mín',
      'time': 'Tempo',
      'quantity': 'Quantidade',
      'diameter': 'Diâmetro',
      'length': 'Comprimento',
      'ploomesProductName': 'Produto Ploomes',
      'thickness': 'Espessura',
      'weight': 'Peso',
      'width': 'Largura',
      'requestedProduct': 'Produto Solicitado',
      'offeredProduct': 'Produto Oferecido',
      'deadlines': 'Prazos',
      'heatTreatments': 'Tratamentos Térmicos',
      'segment': 'Segmento',
      'price': 'Preço',
      'cost': 'Custo',
      'stock': 'Estoque',
      'category': 'Categoria',
      'type': 'Tipo',
      'unit': 'Unidade',
      'model': 'Modelo',
      'costPerHour': 'Custo/Hora',
      'capacity': 'Capacidade',
      'dimension': 'Dimensão',
      'manufacturer': 'Fabricante',
      'year': 'Ano',
      'locationId': 'ID da Localização',
      'typeId': 'ID do Tipo',
      'deadlineInDays': 'Prazo (Dias)',
      'lengthInMm': 'Comprim. (mm)',
      'stockUnit': 'Unid. Estoque',
      'totalWeight': 'Peso Total',
      'unitQuantity': 'Qtd Unitária'
    }
    
    return translations[key] || key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1')
  }
  
  const getIntegrationFieldsConfig = () => {
    if (!integrationConfig) return []
    
    const data = sampleData || (field as any).integrationData
    if (!data) return []
    
    const fieldKey = integrationConfig.fieldKey
    const excludeKeys = ['id', fieldKey, 'tenantId', 'createdAt', 'updatedAt', 'updateAt', 'deletedAt']
    
    const fields: any[] = []
    
    const processObject = (obj: any, prefix = '') => {
      Object.keys(obj).forEach(key => {
        const fullKey = prefix ? `${prefix}.${key}` : key
        const value = obj[key]
        
        if (excludeKeys.includes(key) || key.toLowerCase().includes('id')) return
        
        if (value && typeof value === 'object' && !Array.isArray(value)) {
          processObject(value, fullKey)
        } else if (value !== null && value !== undefined && value !== '' && !Array.isArray(value)) {
          fields.push({
            key: fullKey,
            label: translateFieldLabel(key),
            render: (val: any) => {
              const displayVal = typeof val === 'object' ? val?.name || val?.companyName || val?.id || String(val) : String(val)
              
              if (key.toLowerCase() === 'cnpj') return maskCnpj(displayVal)
              if (key.toLowerCase() === 'cpf') return maskCpf(displayVal)
              if (key.toLowerCase().includes('phone') || key.toLowerCase().includes('telefone') || key.toLowerCase().includes('celular')) {
                const digits = displayVal.replace(/\D/g, '')
                if (digits.length === 11) return digits.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
                if (digits.length === 10) return digits.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3')
              }
              return displayVal
            },
            condition: (option: any) => {
              const keys = fullKey.split('.')
              let val = option
              for (const k of keys) {
                val = val?.[k]
              }
              return val !== null && val !== undefined && val !== ''
            },
            getValue: (option: any) => {
              const keys = fullKey.split('.')
              let val = option
              for (const k of keys) {
                val = val?.[k]
              }
              return val
            }
          })
        }
      })
    }
    
    processObject(data)
    
    return fields.slice(0, 10)
  }
  return (
    <>
      <Label>{field.pipelineField.name}</Label>
      {isIntegrated && integrationConfig ? (
        <InfiniteSelect
          placeholder='Selecione...'
          value={getIntegrationDisplayValue()}
          onSelect={handleIntegrationSelect}
          fetchFunction={fetchIntegrationData}
          mode={integrationConfig.integrationType === 'write' ? 'crud' : 'readonly'}
          allowCreate={integrationConfig.integrationType === 'write'}
          allowDelete={false}
          getOptionLabel={(option) => {
            const fieldKey = integrationConfig.fieldKey
            const displayValue = getDisplayValueFromField(option, fieldKey)
            if (!displayValue) {
              return option.name || option.companyName || String(option.id || '')
            }
            return displayValue
          }}
          fieldsConfig={getIntegrationFieldsConfig()}
          showDefaultFields={true}
          endpointConfig={integrationConfig.integrationType === 'write' ? {
            listPath: integrationConfig.endpoint,
            createPath: integrationConfig.createEndpoint || integrationConfig.endpoint
          } : undefined}
        />
      ) : isCheckbox ? (
        <>
          <HiddenCheckbox checked={field.booleanValue || false} onChange={handleToggle} />
          <StyledCheckbox checked={field.booleanValue || false} onClick={handleToggle} />
        </>
      ) : isValor ? (
        <CurrencyInput
          id={`currency-${field.pipelineFieldId}`}
          name={`currency-${field.pipelineFieldId}`}
          value={field.decimalValue || 0}
          onValueChange={handleDecimalChange}
          placeholder='R$ 0,00'
        />
      ) : isDate ? (
        <Input
          isFilled={isFilled === false && field.isRequired === true ? false : undefined}
          type='date'
          placeholder='Selecione...'
          value={field.dateTimeValue ? field.dateTimeValue.split('T')[0] : ''}
          onChange={(e) => handleDateChange(e.target.value)}
        />
      ) : (
        <Input
          isFilled={isFilled === false && field.isRequired === true ? false : undefined}
          type={isEmail ? 'email' : 'text'}
          placeholder={placeholder}
          value={field.stringValue || ''}
          onChange={(e) => handleStringChange(e.target.value)}
        />
      )}
    </>
  )
}

export default RenderField